export default __webpack_public_path__ + "static/media/photo--lg--42.08c5136d.jpg";